/**************************************************
 * Nombre:       Formulario_Ingreso
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {LockOutline, MailOutline} from "@mui/icons-material";

const Formulario_Ingreso = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={MailOutline} nombre={'Correo'} dato={'correo'} {...props}
                                  requerido={'El Correo es requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={LockOutline} nombre={'Contraseña'} dato={'pass'}
                                  type={'password'} {...props}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Ingreso